<template>
  <PricingIntro />
  <GuideSection class="bg-white" pt="0">
    <PricingDetails :loading="loading" :plans="plans" pad />
  </GuideSection>
  <SaveBig />
  <PricingFaqs />
  <GetStarted class="guide-divider" pricing-page />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PricingIntro from "@/components/sections/PricingIntro.vue";
import PricingDetails from "@/components/elements/Pricing";
import SaveBig from "@/components/sections/SaveBig";
import PricingFaqs from "@/components/sections/PricingFaqs.vue";
import GetStarted from "@/components/sections/GetStarted.vue";

export default defineComponent({
  components: {
    PricingIntro,
    PricingDetails,
    SaveBig,
    PricingFaqs,
    GetStarted,
  },
  setup() {
    const keywords = seoKeywords();

    definePageMeta({
      headerDark: true,
      layout: "sell",
      seo: {
        title: "Orie Pricing | Free Trial",
        description:
          "Launch your store in minutes—choose a plan when you’re ready, starting from just A$1.",
        // "Set up your business, pick a free or paid plan later. No credit card required.",
        keywords: [
          "Orie pricing",
          "Orie price",
          "Orie free",
          ...keywords.sell.home,
        ],
      },
    });

    const plan = ref<string>();
    const { loading, plans } = usePlans();

    return {
      plan,
      plans,
      loading,
    };
  },
  methods: {
    register() {
      // const query: any = { trial: '' }
      // if (this.email) query.email = this.email
      // if (this.plan) query.plan = this.plan
      // if (this.period) query.period = this.period
      // // @ts-ignore
      // this.$router.push({
      //   name: 'register',
      //   query,
      // })
    },
    selectPricing(plan: string) {
      this.plan = plan;
      this.register();
    },
  },
});
</script>
